import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/services';
import { ActivatedRoute, Router } from '@angular/router'
import {
  ClientTopServices,
  MatrixServices,
  ModalService,
  RestServices,
  SharedServices,
  StateServices,
} from '../../../services'

@Component({
  selector: 'app-layout-app-not-found',
  templateUrl: './layout-app-not-found.component.html',
  styleUrls: ['./layout-app-not-found.component.css',
    '../../../stagingcss/root-ui-view.component.css',
    '../../../stagingcss/main-body.component.css',
    '../../../stagingcss/main-view.component.css',
    '../../../stagingcss/lui-select.component.css',]
})
export class LayoutAppNotFoundComponent implements OnInit {

  constructor(private auth: AuthService, private router: Router, private routetActive: ActivatedRoute,) {
  }

  isClient = true

  ngOnInit() {
    // set class display theme
    if (localStorage.getItem('classThemeBody')) {
      jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
    }
    if (this.routetActive.url['value'][1].path == 'client') {
      this.isClient = true
    } else {
      this.isClient = false
    }
  }

  checkRedirect(routesLink, activeIndex) {
    this.router.navigate([routesLink])
  }


}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/layout-app-not-found/layout-app-not-found.component.ts